import type {ReactElement} from 'react';
import React from 'react';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import {TextSlideBottomBar} from '@Components/poster-editor/components/poster-editor-bottom-bar/components/text-slide-bottom-bar';
import {MediaSlideBottomBar} from '@Components/poster-editor/components/poster-editor-bottom-bar/components/media-slide-bottom-bar';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';

export function SlideshowBottomBar(): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;

  if (!activeItem?.isSlideshow()) {
    return null;
  }

  if (!activeSlide) {
    return null;
  }

  const getBottomForSlideShowItems = (): ReactElement<any> | null => {
    switch (activeSlide.gitype) {
      case ITEM_TYPE.IMAGESLIDE:
        return <MediaSlideBottomBar />;
      case ITEM_TYPE.VIDEOSLIDE:
        return <MediaSlideBottomBar />;
      case ITEM_TYPE.TEXTSLIDE:
        return <TextSlideBottomBar />;
      default:
        return null;
    }
  };

  return getBottomForSlideShowItems();
}
